import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';

@Component({
  selector: 'activity-row-deal-document-requirement-override',
  template: `
    <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
      <mat-icon>remove_circle_outline</mat-icon>
    </div>
    <div class="description">
      <strong>Deal Document Requirement Overridden</strong>
      <div class="text">
        @if (activity.meta?.overrideUserId && activity.meta?.overrideUserId === lenderUser()?.id) {   
          You
        } @else {
          {{ activity.meta?.overrideUserName }}
        }
        overrode {{ documentCategory }} for deal {{ activity.dealId }} [{{ activity.meta?.institutionName}}].
        <div class="tw-ml-[36px] tw-max-w-[400px] tw-font-semibold">
        Reason for override:
        <div [innerHTML]="activity.meta?.overrideReason" class="tw-text-lendio-cool-gray-400 tw-font-normal tw-text-xs"></div>
      </div>
      </div>
    </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowDealDocumentRequirementOverrideComponent implements OnInit {
  lenderUser = this.store.selectSignal(LenderUserState.lenderUser);
  @Input() activity;
  documentCategory: string;

  constructor(
    private store: Store,
  ) {}

  ngOnInit() {
    this.documentCategory = this.formatFieldToSentenceCase(this.activity?.meta?.loanProductQuestionField);
  }

  formatFieldToSentenceCase(field: string): string {
    if (!field) {
      return 'unknown';
    }
    
    // Handle snake_case: replace underscores with spaces
    let formattedValue = field.replace(/_/g, ' ');
    
    // Handle camelCase: add spaces before capital letters
    formattedValue = formattedValue.replace(/([a-z])([A-Z])/g, '$1 $2');
    
    // Capitalize first letter of each word
    return formattedValue.replace(/\b\w/g, char => char.toUpperCase());
  }
}
